import { createSlice } from '@reduxjs/toolkit'

// Setup the initial state

const initialState = {
  insertClientpartialData: {},
  consultClientPartialData: {},
  consultExistingClientData: {},
  consultFormValues: null,
  values: null,
  showModuleIntro: true,
  module: 0,
  formStep: 0,
};

export const formsSlice = createSlice({
  name: 'forms',
  initialState,
  reducers: {

    // Insert Client Partial Registration Data

    setInsertClientpartialDataLoading: (state) => {
      state.insertClientpartialData = {
        isLoading: true,
      };
    },

    setInsertClientpartialDataSuccess: (state, action) => {
      state.insertClientpartialData = {
        data: action.payload
      };
    },

    setInsertClientpartialDataFailure: (state, action) => {
      state.insertClientpartialData = {
        error: action.payload,
      }
    },


    // Consult Client Partial Registration Data

    setConsultClientPartialDataLoading: (state) => {
      state.consultClientPartialData = {
        isLoading: true,
      };
    },

    setConsultClientPartialDataSuccess: (state, action) => {
      state.consultClientPartialData = {
        data: action.payload
      };
    },

    setConsultClientPartialDataFailure: (state, action) => {
      state.consultClientPartialData = {
        error: action.payload,
      }
    },

    cleanUpConsultClientPartialData: (state, action) => {
      state.consultClientPartialData = {}
    },


    // Consult Existing Client Data

    setConsultExistingClientDataLoading: (state) => {
      state.consultExistingClientData = {
        isLoading: true,
      };
    },

    setConsultExistingClientDataSuccess: (state, action) => {
      state.consultExistingClientData = {
        data: action.payload
      };
    },

    setConsultExistingClientDataFailure: (state, action) => {
      state.consultExistingClientData = {
        error: action.payload,
      }
    },

    cleanUpConsultExistingClientData: (state) => {
      state.consultExistingClientData = {}
    },

    setConsultFormValues: (state, action) => {
      state.consultFormValues = action.payload;
    },

    setFormValues: (state, action) => {
      state.values = action.payload;
    },

    setShowModuleIntro: (state, action) => {
      state.showModuleIntro = action.payload;
    },

    setModule: (state, action) => {
      state.module = action.payload;
    },

    setFormStep: (state, action) => {
      state.formStep = action.payload;
    },

    resetFormSteps: () => initialState,
  },
})

export const { 
  setInsertClientpartialDataLoading, setInsertClientpartialDataSuccess, setInsertClientpartialDataFailure,
  setConsultClientPartialDataLoading, setConsultClientPartialDataSuccess, setConsultClientPartialDataFailure, cleanUpConsultClientPartialData,
  setConsultExistingClientDataLoading, setConsultExistingClientDataSuccess, setConsultExistingClientDataFailure, cleanUpConsultExistingClientData,
  setConsultFormValues, setFormValues, setShowModuleIntro, setModule, setFormStep, resetFormSteps,
} = formsSlice.actions

export default formsSlice.reducer;